import { dayjs } from "../services/dayjs";

export const getDateFromArray = ([year, month, day]: number[]) =>
  dayjs(new Date(year, month - 1, day));